import store from '@/store'
import storage from './storage'
const apiUrlProd = window.config ? window.config.apiUrlProd : ''
const authUrl = window.config ? window.config.authUrl : ''
const signalrUrl = window.config ? window.config.signalrUrl : ''
const sendbirdToken = window.config ? window.config.sendbirdToken : ''
const solutions = window.config ? window.config.solutions : []
const channelType = window.config ? window.config.channelType : 'ServiceRequest'
export const imageExtensions = ['jpg', 'jpeg', 'gif', 'png', 'bmp']
export const videoExtensions = ['mp4', 'webm', 'ogg']
export const pdfExtensions = ['pdf']
export const wordDocumentExtensions = ['doc', 'docx']
export const otherDocumentExtensions = ['txt', 'rtf']
export const documentExtensions = [...pdfExtensions, ...wordDocumentExtensions, ...otherDocumentExtensions]
export const allFileExtensions = [...imageExtensions, ...videoExtensions, ...documentExtensions]

export default {
  namespaced: true,
  generateUUID() {
    // Timestamp
    var d = new Date().getTime()
    // Time in microseconds since page-load or 0 if unsupported
    var d2 = (performance && performance.now && (performance.now() * 1000)) || 0
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      // random number between 0 and 16
      var r = Math.random() * 16
      // Use timestamp until depleted
      if (d > 0) {
        r = (d + r) % 16 | 0
        d = Math.floor(d / 16)
      } else {
        // Use microseconds since page-load if supported
        r = (d2 + r) % 16 | 0
        d2 = Math.floor(d2 / 16)
      }
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })
  },
  formatDateTimeCultural: function (date) {
    let language = store.getters['auth/language']
    if (date !== undefined && date !== null) {
      if (language !== '') {
        language += '-' + language.toUpperCase()
        return date.toLocaleString(language)
      } else {
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
      }
    } else {
      return null
    }
  },
  formatDateCultural: function (date) {
    if (date !== undefined && date !== null) {
      let language = store.getters['auth/language']
      if (language !== '') {
        language += '-' + language.toUpperCase()
        return date.toLocaleDateString(language)
      } else {
        return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear()
      }
    }
  },
  formatTimeCultural: function (date) {
    if (date !== undefined && date !== null) {
      let language = store.getters['auth/language']
      if (language !== '') {
        language += '-' + language.toUpperCase()
        return date.toLocaleTimeString(language)
      } else {
        var hours = date.getHours()
        var minutes = date.getMinutes()
        var ampm = hours >= 12 ? 'pm' : 'am'
        hours = hours % 12
        hours = hours || 12 // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes
        var strTime = hours + ':' + minutes + ' ' + ampm
        return strTime
      }
    }
  },
  formatDateTime: function (date) {
    if (date !== undefined && date !== null) {
      let language = store.getters['auth/language']
      if (language !== '') {
        language += '-' + language.toUpperCase()
        return date.toLocaleString(language)
      } else {
        var hours = date.getHours()
        var minutes = date.getMinutes()
        var ampm = hours >= 12 ? 'pm' : 'am'
        hours = hours % 12
        hours = hours || 12 // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes
        var strTime = hours + ':' + minutes + ' ' + ampm
        return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear() + ' ' + strTime
      }
    } else {
      return null
    }
  },
  formatDateTimeLong: function (date) {
    if (date !== undefined && date !== null) {
      var hours = date.getHours()
      var minutes = date.getMinutes()
      hours = hours < 12 ? '0' + hours : hours
      minutes = minutes < 10 ? '0' + minutes : minutes
      var strTime = 'T' + hours + ':' + minutes
      var month = date.getMonth() + 1
      month = month < 10 ? '0' + month : month
      var day = date.getDate()
      day = day < 10 ? '0' + day : day
      return date.getFullYear() + '-' + month + '-' + day + strTime
    } else {
      return null
    }
  },
  formatDateTime2: function (date) {
    var today = new Date()
    var hours = date.getHours()
    var ampm = 'am'
    if (hours >= 12) {
      ampm = 'pm'
    }
    if (hours >= 13) {
      hours = hours - 12
    }
    var year = today.getFullYear()
    if (today.getMonth() === 11 && date.getMonth() === 0) {
      year++
    }
    return (date.getMonth() + 1) + '/' + date.getDate() + '/' + year + ' ' + hours + ':' + date.getMinutes() + ' ' + ampm
  },
  getDay: function () {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    var now = new Date()
    return days[now.getDay()]
  },
  getTime: function (includeSeconds) {
    var now = new Date()
    var ampm = ' am'
    var hours = now.getHours()
    if (hours > 12) {
      hours = hours - 12
      ampm = ' pm'
    }
    var minutes = now.getMinutes()
    if (minutes < 10) {
      minutes = '0' + minutes
    }
    if (includeSeconds !== undefined) {
      if (includeSeconds) {
        var seconds = now.getSeconds()
        if (seconds < 10) {
          seconds = '0' + seconds
        }
        minutes += ':' + seconds
      }
    }
    return hours + ':' + minutes + ampm
  },
  getMessageTime: function (messageTime) {
    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
    var _getDay = val => {
      let lastDigit = parseInt(val.toString().slice(-1))
      let day = parseInt(val)
      if (lastDigit === 1) {
        return day + 'st'
      } else if (lastDigit === 2) {
        return day + 'en'
      } else if (lastDigit === 3) {
        return day + 'rd'
      } else {
        return day + 'th'
      }
    }
    var _checkTime = val => {
      return +val < 10 ? '0' + val : val
    }
    if (messageTime) {
      const LAST_MESSAGE_YESTERDAY = 'YESTERDAY'
      var _nowDate = new Date()
      var _date = null
      if (messageTime !== undefined) {
        _date = new Date(messageTime)
      }
      if (_date !== null) {
        if (_nowDate.getDate() - _date.getDate() === 1) {
          return LAST_MESSAGE_YESTERDAY
        } else if (
          _nowDate.getFullYear() === _date.getFullYear() &&
          _nowDate.getMonth() === _date.getMonth() &&
          _nowDate.getDate() === _date.getDate()
        ) {
          return _checkTime(_date.getHours()) + ':' + _checkTime(_date.getMinutes())
        } else {
          return months[_date.getMonth()] + ' ' + _getDay(_date.getDate())
        }
      } else {
        return ''
      }
    }
    return ''
  },
  isNumeric: function (n) {
    return !isNaN(parseFloat(n)) && isFinite(n)
  },
  getBase64Image: function (img) {
    // https://stackoverflow.com/questions/19183180/how-to-save-an-image-to-localstorage-and-display-it-on-the-next-page
    var canvas = document.createElement('canvas')
    canvas.width = img.width
    canvas.height = img.height
    var ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0)
    var dataURL = canvas.toDataURL('image/png')
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, '')
  },
  get currentPage() {
    return storage.session.getItem('currentPage')
  },
  set currentPage(value) {
    storage.session.setItem('currentPage', value)
  },
  logging: false,
  logEntries: [],
  lookupUrl: function (solution) {
    let _url = apiUrlProd
    solutions.forEach(item => {
      if (parseInt(item.id) === parseInt(solution)) {
        _url = item.url
      }
    })
    return _url
  },
  apiUrl: function () {
    let _url = apiUrlProd
    // let _solution = store.getters['auth/solution']
    let _solution = storage.local.getItem('auth/solution') || 1
    // console.log('Solution (apiUrl)', _solution)
    solutions.forEach(item => {
      if (parseInt(item.id) === parseInt(_solution)) {
        _url = item.url
      }
    })
    return _url
  },
  authUrl: function () {
    let _url = authUrl
    // let _solution = store.getters['auth/solution']
    let _solution = storage.local.getItem('auth/solution') || 1
    // console.log('Solution (authUrl)', _solution)
    solutions.forEach(item => {
      if (parseInt(item.id) === parseInt(_solution)) {
        _url = item.auth
      }
    })
    return _url
  },
  signalrUrl: function () {
    let _url = signalrUrl
    // let _solution = store.getters['auth/solution']
    let _solution = storage.local.getItem('auth/solution') || 1
    // console.log('Solution (apiUrl)', _solution)
    solutions.forEach(item => {
      if (parseInt(item.id) === parseInt(_solution)) {
        _url = item.signalrUrl
      }
    })
    return _url
  },
  get username() {
    return storage.session.getItem('username')
  },
  set username(value) {
    storage.session.setItem('username', value)
  },
  get email() {
    return storage.session.getItem('email')
  },
  set email(value) {
    storage.session.setItem('email', value)
  },
  sendbirdToken: function () {
    let _token = sendbirdToken
    // let _solution = store.getters['auth/solution']
    let _solution = storage.local.getItem('auth/solution') || 1
    // console.log('Solution (sendbirdToken)', _solution)
    solutions.forEach(item => {
      if (parseInt(item.id) === parseInt(_solution)) {
        _token = item.sendbirdToken
      }
    })
    return _token
  },
  channelType: function () {
    let _type = channelType
    // let _solution = store.getters['auth/solution']
    let _solution = storage.local.getItem('auth/solution') || 1
    // console.log('Solution (channelType)', _solution)
    solutions.forEach(item => {
      if (parseInt(item.id) === parseInt(_solution)) {
        _type = item.channelType
      }
    })
    console.log('Channel Type', _type)
    return _type
  },
  appId: function () {
    let _id = 1
    // let _solution = store.getters['auth/solution']
    let _solution = storage.local.getItem('auth/solution') || 1
    // console.log('Solution (appId)', { solutions: solutions, solution: _solution })
    if (solutions.length === 1) {
      _id = solutions[0].appId
    } else {
      solutions.forEach(item => {
        if (parseInt(item.id) === parseInt(_solution)) {
          _id = item.appId
        }
      })
    }
    return _id
  },
  isUK: function() {
    // "UK" is basically anything other than USA/CANADA.
    return parseInt(this.appId()) === 1 // UK is appId=1
  },
  isAustralia: function() {
    return this.name() === 'Australia' // UK is appId=1 but "name" is a deployment variable
  },
  isStGobain: function() {
    return parseInt(parseInt(store.getters['auth/solution'])) === 10 // St.Gobain is Id=10 (appId=1)
  },
  isRepairify: function() {
    let isRepairify = window.location.hostname.toLowerCase().includes('repairify')
    if (isRepairify === false) {
      isRepairify = this.name() === 'Australia'
    }
    if (isRepairify === false) {
      isRepairify = window.location.hostname.toLowerCase().includes('auportal')
    }
    return isRepairify
  },
  isClever: function() {
    let isClever = parseInt(parseInt(store.getters['auth/solution'])) === 11 // St.Gobain is appId=10
    if (isClever === false) {
      isClever = window.location.hostname.toLowerCase().includes('clever')
    }
    if (isClever === false) {
      isClever = window.location.hostname.toLowerCase().includes('clportal')
    }
    return isClever
  },
  getDynamicConfigurationValue: function(lookupKey) {
    const configGroup = storage.local.getItem('CONFIGURATION')

    let configArray
    if (configGroup) {
      configArray = JSON.parse(configGroup.replace(/\\/g, ''))
    } else {
      return false
    }
    if (Array.isArray(configArray)) {
      const lookupItem = configArray.find(item => item.text === lookupKey)
      if (lookupItem) {
        return lookupItem.value === '1'
      } else {
        return false
      }
    }
  },
  isRagEnabled: function() {
    return !this.isMahle() && this.getDynamicConfigurationValue('RagRatingEnabled')
  },
  isOpeningHoursEnabled: function() {
    return !this.isMahle() && this.getDynamicConfigurationValue('OpeningHoursEnabled')
  },
  isMahleRagEnabled: function() {
    return this.isMahle() && this.getDynamicConfigurationValue('MAHLERagRatingEnabled')
  },
  isMahleOpeningHoursEnabled: function() {
    return this.isMahle() && this.getDynamicConfigurationValue('MAHLEOpeningHoursEnabled')
  },
  isChatFileUploadEnabled: function() {
    return this.getDynamicConfigurationValue('ChatFileUploadEnabled')
  },
  isSendbirdAuditingEnabled: function() {
    return this.getDynamicConfigurationValue('SendbirdAuditEnabled')
  },
  clientSurveyConfigKey: function() {
    return this.isMahle() ? 'MAHLEClientSurveyEnabled' : 'ClientSurveyEnabled'
  },
  isClientSurveyEnabledForThisTenant: function() {
    const key = this.clientSurveyConfigKey()
    return !!(this.getDynamicConfigurationValue(key))
  },
  isLaunch: function() {
    return window.location.hostname.toLowerCase().includes('launch')
  },
  isUKPortal3: function() {
    return window.location.hostname.toLowerCase().includes('uk') && window.location.hostname.toLowerCase().includes('portal3')
  },
  isGlass: function() {
    return window.location.hostname.toLowerCase().includes('glass')
  },
  isMahle: function() {
    return this.isUK() && window.location.hostname.toLowerCase().includes('remotepro')
  },
  get isUserProfileComplete() {
    return storage.session.getItem('isUserProfileComplete')
  },
  set isUserProfileComplete(value) {
    storage.session.setItem('isUserProfileComplete', value)
  },
  appName: function () {
    let _name = ''
    let _solution = storage.local.getItem('auth/solution') || 1
    if (solutions.length === 1) {
      _name = solutions[0].appName
    } else {
      solutions.forEach(item => {
        if (parseInt(item.id) === parseInt(_solution)) {
          _name = item.appName
        }
      })
    }

    if (this.isMahle()) {
      return 'mahle.label.portaltitle'
    }
    return _name
  },
  name: function () {
    let _name = ''
    let _solution = storage.local.getItem('auth/solution') || 1
    if (solutions.length === 1) {
      _name = solutions[0].name
    } else {
      solutions.forEach(item => {
        if (parseInt(item.id) === parseInt(_solution)) {
          _name = item.name
        }
      })
    }
    return _name
  },
  defaultLanguage: function () {
    let _defaultLanguage = window.config ? window.config.language : 'en'
    let _solution = storage.local.getItem('auth/solution') || 1
    if (solutions.length === 1) {
      if (solutions[0].defaultLanguage) {
        _defaultLanguage = solutions[0].defaultLanguage
      }
    } else {
      solutions.forEach(item => {
        if (parseInt(item.id) === parseInt(_solution)) {
          if (item.defaultLanguage) {
            _defaultLanguage = item.defaultLanguage
          }
        }
      })
    }
    console.log('defaultLanguage : ', _defaultLanguage)
    return _defaultLanguage
  },
  sortArray(data) {
    let _data = Array.from(new Set(data)).sort(function (a, b) {
      if (a[0] === b[0]) {
        var x = a['name']
        var y = b['name']
        return x < y ? -1 : x > y ? 1 : 0
      }
      return a[0] - b[0]
    })
    return _data
  },
  jsonToQueryString(json) {
    let query = ''
    if (json !== undefined && json !== null) {
      query = '?' + Object.keys(json).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
      }).join('&')
    }
    return query
  },
  scrollToBottom(target) {
    // setTimeout(() => {
    //   var element = window.vueApp.$el.querySelector(`#${target}`)
    //   element.scrollTop = element.scrollHeight - element.clientHeight
    // }, 250)
  },
  logoPath: function () {
    let _domainLogo = null
    let _logoPath = '/static/logo.png'

    let _solution = storage.local.getItem('auth/solution') || 1

    if (solutions.length === 1) {
      _domainLogo = solutions[0].domainLogo
    } else {
      solutions.forEach(item => {
        if (parseInt(item.id) === parseInt(_solution)) {
          _domainLogo = item.domainLogo
        }
      })
    }

    console.log('Current domain name:', window.location.hostname)

    if (_domainLogo) {
      console.log(_domainLogo)
      _domainLogo.forEach(item => {
        item.domainName.forEach(dnItem => {
          if (dnItem === window.location.hostname) {
            console.log('Domain name:', dnItem)
            _logoPath = item.logoPath
          }
        })
      })
    }

    return _logoPath
  },
  getCultureCode(code) {
    var cultureCode = code
    switch (code) {
      case 'en':
      case 'en-EN': // United States
        cultureCode = 'en-US'
        break
      case 'el':
      case 'gr':
      case 'el-EL': // Greek
        cultureCode = 'el-GR'
        break
      case 'sv': // Swedish
        cultureCode = 'sv-SE'
        break
      case 'uk': // Ukraine
        cultureCode = 'uk-UA'
        break
      case 'sl': // slovenia
        cultureCode = 'sl-SI'
        break
      case 'sr': // Serbia
        cultureCode = 'sr-RS'
        break
      case 'no': // Norwegian
      case 'nb':
        cultureCode = 'nb-NO'
        break
      case 'et': // Estonian
        cultureCode = 'et-EE'
        break
      case 'bs': // Bosnian
        cultureCode = 'bs-BA'
        break
      case 'be': // Belarusian
        cultureCode = 'be-BY'
        break
      case 'da': // Danish
        cultureCode = 'da-DK'
        break
      case 'sq': // Albania
        cultureCode = 'sq-AL'
        break
      default:
        cultureCode = code + '-' + code.toUpperCase()
        break
    }
    return cultureCode
  },
  hasRagOnlyRole(userProfile) {
    if (!userProfile || !userProfile.roles) {
      return false
    }
    return userProfile.roles.some(role =>
      role.Id === 14 ||
      role.id === 14 ||
      (role.Name && role.Name.toLowerCase() === 'rag only')
    )
  }
}



// WEBPACK FOOTER //
// ./src/plugins/globals.js